import { Scripts } from './prod.script';

// EN-4426: UAT chat bubble is HubSpot (replaces ZenDesk). Uses the NA1 loader from the
// ticket embed; kept as a separate UAT-only entry. Same HubSpot portal (46950108) as prod
// — UAT vs Production is distinguished by the HubSpot ticket workflow (Source URL), not the loader.
export const UATScript: Scripts[] = [
	{
		name: 'hs-script-loader',
		src: '//js-na1.hs-scripts.com/46950108.js',
	},
];
